var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-index"},[_c('h-banner'),_c('h-minor-banner'),_c('h-main'),_c('h-float-icon'),_c('h-foot')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }